var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-page-header'),_c('v-container',{staticClass:"box",attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg8":"","xl6":""}},[_c('parking-spaces')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }